import type {
  DirectiveConfig,
  MinimalDOMPurifyConfig,
} from 'vue-dompurify-html'

import domPurifyConfig from '@app/shared/config/dom-purify'

// Prompt injection puts AI markdown under the control of whoever wrote the
// documents the model read, so it may load no remote URL and may carry no
// `style`, `class` or `id`. The global Tailwind utilities build a full-screen
// phishing overlay out of `class` alone.
export const aiMarkdownConfig: MinimalDOMPurifyConfig = {
  ...domPurifyConfig,
  ALLOWED_TAGS: [
    'p',
    'br',
    'hr',
    'span',
    'div',
    'strong',
    'b',
    'em',
    'i',
    'del',
    's',
    'ins',
    'mark',
    'sub',
    'sup',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'dl',
    'dt',
    'dd',
    'blockquote',
    'pre',
    'code',
    'a',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'caption',
  ],
  ALLOWED_ATTR: [
    'href',
    'title',
    'lang',
    'dir',
    'align',
    'colspan',
    'rowspan',
    'start',
    'reversed',
  ],
  ALLOWED_URI_REGEXP:
    /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
  ALLOW_DATA_ATTR: false,
}

export const domPurifyPluginOptions: DirectiveConfig = {
  default: domPurifyConfig,
  namedConfigurations: {
    noHtml: {
      ...domPurifyConfig,
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    },
    allowTarget: {
      ...domPurifyConfig,
      ADD_ATTR: ['target'],
    },
    aiMarkdown: aiMarkdownConfig,
  },
}
